module.exports = __webpack_public_path__ + "ClinicaPro-Regular-webfont.425ff19041d073cce82c.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/ClinicaPro-Regular-webfont.eot
// module id = ../../../../../src/assets/fonts/ClinicaPro-Regular-webfont.eot
// module chunks = styles